export default "__VITE_ASSET__BSDdKfOJ__"